var map = {
	"./ads-selected.png": 823,
	"./ads.png": 1164,
	"./categories-selected.png": 69,
	"./categories.png": 538,
	"./challenges-selected.png": 9106,
	"./challenges.png": 2,
	"./logs-selected.png": 7449,
	"./logs.png": 1354,
	"./orders-selected.png": 3624,
	"./orders.png": 3718,
	"./users-selected.png": 3793,
	"./users.png": 2291
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9952;